<div>
    <span>{{ dateList[index] | date:'dd/MM/yyyy' }}</span>
</div>
<div>
    <div class="item">
        <span>{{ fuitesList[index] ? (fuitesList[index] | number: '1.2-2') : 'Pas de donnée' }}</span>
    </div>
</div>